import { logEvent } from 'commons/utils/tracking';
import { MENU_SECONDARY_SEO_REDIRECTS_CLICK } from 'config/trackingEvents';

export const menuSecondarySeoRedirectsClick = () => {
  logEvent(MENU_SECONDARY_SEO_REDIRECTS_CLICK, {});
};
